module.exports = __webpack_public_path__ + "static/media/canva_logo.c4f9b628.png";